// React Hook for Configuration
// This hook provides dynamic configuration loading from JSON files

import { useState, useEffect } from 'react';
import { DefaultConfig } from './defaultConfig';
import { loadCompleteConfig, getServerConfigSync } from './configLoader';

export const useConfig = () => {
  const [config, setConfig] = useState<DefaultConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Load the complete configuration
        const loadedConfig = await loadCompleteConfig();
        setConfig(loadedConfig);
        
        console.log('✅ Configuration loaded successfully:', loadedConfig);
      } catch (err) {
        console.error('❌ Failed to load configuration:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  // Get server configuration synchronously (for immediate use)
  const getServerConfig = () => getServerConfigSync();

  return {
    config,
    loading,
    error,
    getServerConfig
  };
};

// Hook for server configuration only
export const useServerConfig = () => {
  const [serverConfig, setServerConfig] = useState(getServerConfigSync());

  const updateServerConfig = (newConfig: any) => {
    setServerConfig(newConfig);
  };

  return {
    serverConfig,
    updateServerConfig
  };
}; 